import type { DefaultOptions } from '@tanstack/react-query';

import { setupQueryClient } from './query-client';

export interface Config {
  domains: {
    auth: string;
    members: string;
    plans: string;
    reports: string;

    membersV2: string;
  };
  paths: {
    auth: string;
    members: string;
    plans: string;
    reports: string;
  };
  queryClientOptions: DefaultOptions;
  getToken: () => Promise<string | null>;
  setToken: (key: 'access_token' | 'impersonated_token', token: string) => Promise<void>;
  clearToken: () => Promise<void>;
}

let globalConfig: Config | null = null;

export const setup = (config: Config) => {
  globalConfig = config;
  setupQueryClient(config.queryClientOptions);
};

export const getConfig = () => {
  if (!globalConfig) throw new Error('API Configuration is not set.');

  return globalConfig;
};

export const STATIC_OPTIONS = true;
